import { Action } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/types/PendingAction';

export const isSignatureAction = (action: Action | undefined) =>
  action === Action.SIGN_CONTRACT || action === Action.COMPLETE_PROCESS_SANTANDER;
